// frontend/src/components/loading/LazySettingsPageSkeleton.js
//
// The /settings page skeleton (SettingsPageSkeleton.js), loaded on demand - the
// fallback appRoutes.js gives /settings while the Settings chunk downloads
// (inside PageBodySuspense, under the real navbar).
//
// WHY LAZY. The settings skeleton draws every tab's panel
// (SettingsPanelSkeletons.js behind it), and a static import from the route
// table put all of it in the main chunk every visitor downloads - anonymous
// homepage visitors included. So it gets its own chunk, and ProtectedRoute
// starts that chunk as soon as it knows a visitor is signed in (every
// signed-in tier can open /settings - components/ProtectedRoute.js), so
// normally it is in long before /settings is opened and renders with no wait.
// The Settings page itself keeps its static imports of the same parts: it is a
// lazy chunk already.
//
// How it loads, what it shows meanwhile (nothing), and why a failed chunk
// renders nothing and is retried on the next mount instead of breaking the
// page: utils/lazySkeleton.js, shared with LazyAdminPageSkeleton.js.

import lazySkeleton from "../../utils/lazySkeleton";

/**
 * SettingsPageSkeleton, code-split. Takes exactly SettingsPageSkeleton's props
 * and forwards all of them (the language PageBodySuspense injects, anything
 * added later). `.preload()` starts (or joins) the chunk download and never
 * rejects.
 *
 * @type {React.ComponentType & {preload: () => Promise<unknown>}}
 */
const LazySettingsPageSkeleton = lazySkeleton(() => import("./SettingsPageSkeleton"));

export default LazySettingsPageSkeleton;
